import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
	selector: '[validateEquals][formControlName],[validateEquals][ngModel]',
	providers: [
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualsValidator), multi: true }
	]
})
export class EqualsValidator implements Validator {

	//@Input() validateEquals: FormControl;

    constructor(
		@Attribute('validateEquals') public validateEquals: string
	) {  }

	validate(control: AbstractControl): { [key: string]: any } | null {
	//validate(control: AbstractControl): ValidationErrors | null {
        /*
		if (!this.subscribe) {
			this.subscribe = true;
			this.validateEquals.valueChanges.subscribe(() => {
				control.updateValueAndValidity();
			});
        }*/

        // self value
        let sv = control.value;

        // compare object
        //let co = this.validateEquals.value;
		let co = control.root.get(this.validateEquals);

		return (co && sv && sv !== co.value) ? {validateEquals: true} : null;
		
		
	}
}



// WEBPACK FOOTER //
// ./src/app/common/equals-validator.directive.ts